import { createSelector } from 'reselect';

export const getIds = ({ homepage }) => homepage.list.allIds;
export const getById = ({ homepage }) => homepage.byId;
export const getHomePage = (state, id) => getById(state)[id];
export const getHomePageList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));
